import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, RefreshCw } from 'lucide-react';

interface CustomFormSuccessProps {
  responseId: string;
  onReset: () => void;
}

const CustomFormSuccess = ({ responseId, onReset }: CustomFormSuccessProps) => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl shadow-2xl border-border/70 bg-card/90 backdrop-blur-sm">
        <CardHeader className="text-center pb-6">
          <div className="mx-auto mb-4 w-16 h-16 bg-gradient-to-r from-primary via-brand-coral to-brand-amber rounded-full flex items-center justify-center">
            <CheckCircle className="w-8 h-8 text-primary-foreground" />
          </div>
          <CardTitle className="text-3xl font-bold text-primary">
            Form Submitted Successfully!
          </CardTitle>
          <CardDescription className="text-lg text-muted-foreground">
            Thank you for your valuable feedback
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-6">
          <div className="bg-secondary/60 rounded-lg p-4 border border-border">
            <div className="flex items-center gap-2 mb-2">
              <CheckCircle className="w-5 h-5 text-primary" />
              <h3 className="text-lg font-semibold text-foreground">Submission Confirmed</h3>
            </div>
            <p className="text-foreground">
              Your form response has been successfully submitted and recorded in our system.
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              Response ID: <code className="bg-secondary px-2 py-1 rounded">{responseId}</code>
            </p>
          </div>
          
          <div className="text-center space-y-4">
            <p className="text-muted-foreground">
              Your feedback helps us improve our products and services. We appreciate you taking the time to share your thoughts with us.
            </p>
            <p className="text-sm text-muted-foreground">
              You can close this window or submit another response if needed.
            </p>
          </div>

          <div className="flex justify-center">
            <Button
              onClick={onReset}
              variant="outline"
              className="flex items-center gap-2"
            >
              <RefreshCw className="w-4 h-4" />
              Submit Another Response
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CustomFormSuccess; 